import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToList'
})
export class EnumToListPipe implements PipeTransform {
  transform(enumObj: Object) : any {
    return Object.keys(enumObj).filter(e => !isNaN(+e)).map(o => { return {key: +o, value: enumObj[o]}});
  }

}
